export const AMStore = {
    parseFloat: value =>
        typeof value === 'string'
        ? parseFloat(value.replace(',', '.'))
        : value
}
